<template>
	<az-container class="listagem ml-0 mb-1">
		<v-row class="mt-2">
			<v-col>
				<h1 class="title font-weight-bold color-titulo">Itens</h1>
			</v-col>
			<v-col class="d-flex justify-end">
				<az-search
					:filter="filtroIdAtaButtonsValues"
					simple-search-placeholder="Busque por código ou descrição"
					@simple-search="buscar"
					ref="componenteAzSearch"
					@remove-filter="removerFiltros"
				>
				</az-search>
			</v-col>
		</v-row>

		<div class="">
			<v-row>
				<v-col cols="12" sm="12" class="">
					<listagem-itens-adesao-view
						:itens="datasource"
						:total-paginas="totalPaginas"
						:total-itens="totalItens"
						:paginacao="paginacao"
						@paginar="setPaginacao"
						@resetar-page="resetarPaginaItemListagem"
					></listagem-itens-adesao-view>
				</v-col>
			</v-row>
		</div>
	</az-container>
</template>
<script>
import { mapState } from 'vuex'
import mutationTypes from '@/core/constants/mutation-types'
import { actionTypes } from '@/core/constants'
import ListagemItensAdesaoView from '@/views/pages/adesao/publica/itens/listagem/ListagemItensAdesaoView.vue'

export default {
	name: 'pesquisa-itens-adesao-view',
	components: { ListagemItensAdesaoView },
	data() {
		return {
			paginacao: this.$store.state.adesaoPublica.paginacao,
		}
	},
	computed: {
		...mapState({
			filtro: (state) => state.adesaoPublica.filtro,
			idSolicitacaoAdesao: (state) => state.adesaoPublica.idSolicitacaoAdesao,
			datasource: (state) => state.adesaoPublica.datasource,
			totalPaginas: (state) => state.adesaoPublica.totalPaginas,
			totalItens: (state) => state.adesaoPublica.totalItens,
		}),
		filtroIdAtaButtonsValues() {
			const { idAta, ...resto } = this.filtro
			return resto
		},
	},
	async mounted() {
		await this.carregarItens()
	},
	beforeDestroy() {
		this.$store.state.adesaoPublica.idSolicitacaoAdesao.value = null
	},
	methods: {
		async buscar(searchText) {
			if (searchText) {
				this.filtro.codigoOuDescricaoItem.value = searchText
			}

			this.resetarPaginaItemListagem()
			await this.carregarItens()
		},
		async carregarItens() {
			this.filtro.idAta = { value: this.$route.params.id }
			const retorno = await this.$store.dispatch(actionTypes.ADESAO_PUBLICA.BUSCAR_ITENS_POR_FILTRO)
			this.$store.commit(mutationTypes.ADESAO_PUBLICA.SET_INFORMACOES_ITENS, retorno)
		},
		setPaginacao(paginacao) {
			this.$store.commit(mutationTypes.ADESAO_PUBLICA.SET_PAGINACAO_LISTAGEM, paginacao)
			this.carregarItens()
		},
		async removerFiltros(propriedade) {
			if (this.filtro[propriedade]) {
				this.filtro[propriedade].value = this.filtro[propriedade].default
			}
			await this.carregarItens()
		},
		resetarPaginaItemListagem() {
			this.$store.commit(mutationTypes.ADESAO_PUBLICA.RESETAR_PAGINA_LISTAGEM)
		},
	},
}
</script>
<style scoped lang="stylus"></style>
